import { memo } from "react";

import { useTranslation } from 'react-i18next';
const shimmerClass =
  "relative overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/10 before:to-transparent";

function SkeletonBlock({ className = "" }) {
    const { t } = useTranslation();
return (
    <div
      className={`bg-zinc-800/60 rounded ${shimmerClass} ${className}`}
    />
  );
}

/**
 * SkeletonTable — placeholder table for experiments, automations, referrals.
 * Renders a header row + N data rows with shimmer animation.
 */
const SkeletonTable = memo(function SkeletonTable({
  rows = 5,
  columns = 4,
  columnWidths = null,
}) {
  // Default column widths if not specified
  const widths = columnWidths || ["w-24", "w-32", "w-20", "w-16"];

  return (
    <div className="border border-zinc-800 bg-zinc-950/30 overflow-hidden">
      {/* Table header */}
      <div className="px-4 py-3 border-b border-zinc-800 bg-zinc-950/50 flex gap-4">
        {Array.from({ length: columns }).map((_, i) => (
          <SkeletonBlock
            key={`header-${i}`}
            className={`h-4 ${widths[i % widths.length]}`}
          />
        ))}
      </div>

      {/* Table rows */}
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <div
          key={`row-${rowIdx}`}
          className="px-4 py-3 border-b border-zinc-800/50 flex gap-4"
        >
          {Array.from({ length: columns }).map((_, colIdx) => (
            <SkeletonBlock
              key={`cell-${rowIdx}-${colIdx}`}
              className={`h-4 ${widths[colIdx % widths.length]}`}
            />
          ))}
        </div>
      ))}
    </div>
  );
});

export default SkeletonTable;
